import React from "react";
import { RichiestaTipo } from "../../../domain/richieste";

const CarrelloRichiesta = ({
  tipo,
  criteriInvio,
  indirizzoRiferimento,
  prodotti,
  servizio,
  sellersCount,
  onSubmit,
  onChangeType,
  isSubmitting = false,
  variant = "full",
}) => {
  const isProdotti = tipo === "prodotti";
  const itemsCount = isProdotti ? prodotti.length : servizio.nome ? 1 : 0;
  const contentLabel = isProdotti
    ? `${prodotti.length} prodotto/i`
    : servizio.nome || "Servizio non selezionato";
  const sellersLabel =
    criteriInvio.selectedSellerIds.length > 0
      ? `${criteriInvio.selectedSellerIds.length} selezionate`
      : `${sellersCount} nel raggio`;

  if (variant === "compact") {
    return (
      <button
        type="button"
        className="btn p-0 carrello-richiesta-compact"
        onClick={onSubmit}
        disabled={isSubmitting}
        title={`${contentLabel} - ${sellersLabel}`}
      >
        <span className="d-inline-flex align-items-stretch rounded overflow-hidden carrello-richiesta-compact__shell">
          <span className="d-inline-flex align-items-center p-l-15 p-r-15">
            <i className="fa fa-paper-plane text-white m-r-10"></i>
            <span className="text-white m-r-10">Invia richiesta</span>
            <span className="badge badge-light text-primary">{itemsCount}</span>
          </span>
          <span className="border-left d-inline-flex align-items-center p-l-15 p-r-15 carrello-richiesta-compact__arrow">
            <i className="fa fa-arrow-right text-white"></i>
          </span>
        </span>
      </button>
    );
  }

  return (
    <div className="card">
      <div className="header">
        <h2 className="text-primary">Carrello</h2>
      </div>
      <div className="body">
        <p>
          <strong>Tipo:</strong>{" "}
          <span className="badge badge-info">
            {isProdotti ? RichiestaTipo.PRODOTTI : RichiestaTipo.SERVIZIO}
          </span>
        </p>
        <p>
          <strong>Modalita:</strong>{" "}
          <span className="badge badge-default">{criteriInvio.modalita}</span>
        </p>
        <p>
          <strong>Raggio:</strong>{" "}
          <span className="text-info">{criteriInvio.raggioKm} km</span>
        </p>
        <p>
          <strong>Indirizzo:</strong>{" "}
          <span className="text-info">{indirizzoRiferimento}</span>
        </p>
        <p>
          <strong>Sellers:</strong>{" "}
          <span className="text-success">{sellersLabel}</span>
        </p>
        <p className="m-b-25">
          <strong>Contenuto:</strong>{" "}
          <span className="text-success">{contentLabel}</span>
        </p>
        <div>
          <button
            type="button"
            className="btn btn-primary m-r-10 carrello-richiesta-submit"
            onClick={onSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Invio..." : "Invia richiesta"}
          </button>
          <button
            type="button"
            className="btn btn-default"
            onClick={onChangeType}
          >
            Cambia tipo
          </button>
        </div>
      </div>
    </div>
  );
};

export default CarrelloRichiesta;




